import { useContext, useEffect } from "react";
import { monthNames, transformDate } from "../SearchSportsCamps/data";
import { ActivitiesContext } from "./context/activities-context";

import MoreInfo from "./MoreInfoCard/MoreInfo.jsx";

const ActivitiesCard = (props) => {
	const { setMoreInfoCard, setMoreInfoVisible } =
		useContext(ActivitiesContext);

	useEffect(() => {
		setMoreInfoVisible(props.open);
		setMoreInfoCard(props.activity);
	}, [])

	const shorten = (str, maxLength) => {
		const removeHtml = str.replace(/(<([^>]+)>)/gi, "");
		return `${removeHtml.substr(0, str.lastIndexOf(" ", maxLength))}...`;
	};

	const getPrice = () => {
		if (!props.activity.priceInfo) {
			return "prijs niet meegedeeld";
		} else if (props.activity.priceInfo[0].price > 0) {
			return `${props.activity.priceInfo[0].price} euro`;
		} else if (props.activity.priceInfo[0].price === 0) {
			return "gratis";
		}
	};

	const openDetail = () => {
		setMoreInfoVisible(
			(prevMoreInfoVisible) => !prevMoreInfoVisible
		);
		setMoreInfoCard(props.activity);
	}

	return (
		<>
			<div className="c-fiche c-fiche-full u-has-detail" direct-link="true" onClick={openDetail} data-aos="fade-up">
				<div>
					<div className="type">
						<i className="fa fa-fw fa-calendar-alt"></i>
						<span className="ng-binding ng-scope">
							{transformDate(props.activity.startDate) ===
								transformDate(props.activity.endDate)
								? transformDate(props.activity.startDate)
								: `${transformDate(
									props.activity.startDate
								)} - ${transformDate(
									props.activity.endDate
								)}`}
						</span>
					</div>
					<div
						className="image"
						title={
							props.activity.name.nl &&
							"Meer info over " + props.activity.name.nl
						}
					>
						{props.activity.image ? (
							<img
								className="image-component"
								alt={
									props.activity.name.nl &&
									props.activity.name.nl
								}
								src={props.activity.image}
							></img>
						) : (
							<img
								className="image-component"
								alt="no-image"
								src={"/images/placeholder.png"}
							></img>
						)}
					</div>
					<header className="c-fiche__header">
						<div className="c-tag-list"></div>
						<h2
							className="title"
							title={
								props.activity.name.nl && props.activity.name.nl
							}
						>
							{props.activity.name.nl && props.activity.name.nl}
						</h2>
						{props.activity.description &&
							props.activity.description.nl && (
								<p className="ng-binding">
									{shorten(
										props.activity.description.nl,
										100
									)}
								</p>
							)}
					</header>
					<ul className="c-fiche__body">
						<li className="leaf ng-binding ng-scope">
							<i className="fas fa-fw fa-map-marker-alt"></i>
							{props.activity.location.name &&
								`${Object.values(
									props.activity.location.name
								)}`}
							{props.activity.location.address.nl &&
								`, ${props.activity.location.address.nl.addressLocality}`}
						</li>{" "}
						<li className="leaf ng-binding ng-scope">
							<i className="fas fa-fw fa-eur"></i>
							{getPrice()}
						</li>
					</ul>
					<MoreInfo activity={props.activity} cta={"Meer"} />
				</div>
			</div>
		</>
	);
};

export default ActivitiesCard;
